module.exports = __webpack_public_path__ + "img/guajiang.33c7ef1b.png";